"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateConversionMetrics = exports.conversionMetrics = void 0;
exports.conversionMetrics = {
    AOV: 'AOV',
    conversionsCredit: 'Conversions',
    conversionsRate: 'Conv. Rate',
    CPA: 'Cost / Conv.',
    revenue: 'Conv. Value',
    CRRCos: 'CRR',
    ROAS: 'ROAS',
};
const calculateConversionMetrics = (attribution, conversion) => {
    const conversionsCredit = Number(conversion.conversionCredit);
    const conversionsRate = Number(attribution.visits) > 0 ? Number(conversionsCredit) / Number(attribution.visits) : 0;
    const CPA = conversionsCredit > 0 ? Number(attribution.cost) / conversionsCredit : 0;
    const revenue = Number(conversion.conversionValue);
    const CRRCos = Number(conversion.conversionValue) > 0 ? attribution.cost / revenue : 0;
    const ROAS = Number(attribution.cost) > 0 ? revenue / Number(attribution.cost) : 0;
    const AOV = conversionsCredit > 0 ? revenue / conversionsCredit : 0;
    return {
        AOV,
        conversionsCredit,
        conversionsRate: conversionsRate * 100,
        CPA,
        revenue,
        CRRCos: CRRCos * 100,
        ROAS: ROAS * 100, // in %
    };
};
exports.calculateConversionMetrics = calculateConversionMetrics;
//# sourceMappingURL=conversionMetrics.js.map